import React, { useState } from 'react';
import SideActionBoard from '../../../../../components/SideActionBoard';

import Cohort from './Cohort';

const Sidebar = ({ openSideActionBoard, setOpenSideActionBoard, onSuccess }) => {
  const { action, ids } = openSideActionBoard;

  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <Cohort
        id={ids[0]}
        type={action}
        openSideActionBoard={openSideActionBoard}
        setOpenSideActionBoard={setOpenSideActionBoard}
        onSuccess={onSuccess}
      />
    </SideActionBoard>
  );
};

export default Sidebar;